module.exports = __webpack_public_path__ + "static/the-middle-of-the-world-9b57d47c352c5461d8edd59813cd0dbf.png";